import { createAction } from 'redux-actions';

export const openCommentsDrawerAction = createAction('DRAWERS/OPEN_COMMENTS_DRAWER');
export const setCommentsDrawerParamsAction = createAction('DRAWERS/SET_COMMENTS_DRAWER_PARAMS');
export const setCurrentCommentsThreadIdAction = createAction(
  'DRAWERS/SET_CURRENT_COMMENTS_THREAD_ID',
);
